/** Collections exposed through auto-generated instance CRUD. */
export enum ECollection {
  CATEGORIES = 'categories',
  PRODUCTS = 'products',
  CUSTOMERS = 'customers',
}
